import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useTrackers } from '@ps/web-shared-analytics';
import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import type { CasinoGame, CasinoTable } from '@swf/core/types/CasinoGame';

import { TXTCLI_Play_Now, TXTWCL_Join } from './InfoPlayButton.messages.json';

interface Props {
  className?: string;
  isModal?: boolean;
  fsbLaunch?: boolean;
  raceId?: string;
  game: CasinoGame;
}

const InfoPlayButton: React.FC<Props> = (props) => {
  const siteId = useSelector(select.cms.getSiteId);
  const { modal } = useDispatch<Dispatch>();
  const { casinoGameLaunched } = useTrackers();
  const {
    casino: { launch }
  } = useDispatch<Dispatch>();
  const { className, fsbLaunch, game, raceId } = props;
  const [{ id, playMoney }] = game.tables;

  const onPlayClickHandler = () => {
    modal.close('/casino/game-info');
    launch({ table: { id, playMoney } as CasinoTable, fsbLaunch, raceId, game });
    game && casinoGameLaunched({ game });
  };

  return (
    <StarsButton
      className={className}
      onClick={() => onPlayClickHandler()}
      translation={siteId === Sites.GR ? TXTWCL_Join : TXTCLI_Play_Now}
    />
  );
};

export default InfoPlayButton;
